import { useCallback } from "react";
import { createApiResponse } from "@entrilia/shared/api/axiosHelper";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { getArtifactPreviewKey, loadArtifactPreview } from "./artifactPreviewCache";

export type ArtifactPreviewStatus = "loading" | "ready" | "missing" | "failed";

interface ArtifactPreview {
  status: ArtifactPreviewStatus;
  url?: string;
}

const useArtifactPreview = (artifactId: string, version: number, isEnabled: boolean): ArtifactPreview => {
  const getPreview = useCallback(
    async () =>
      createApiResponse({
        key: getArtifactPreviewKey(artifactId, version),
        url: await loadArtifactPreview(artifactId, version),
      }),
    [artifactId, version]
  );
  const [preview, error, { isFetching }] = useFetch(getPreview, { disabled: !isEnabled });

  if (!isEnabled) {
    return { status: "loading" };
  }
  if (error) {
    return { status: "failed" };
  }
  if (isFetching || preview?.key !== getArtifactPreviewKey(artifactId, version)) {
    return { status: "loading" };
  }
  return preview.url ? { status: "ready", url: preview.url } : { status: "missing" };
};

export default useArtifactPreview;
